// controller to set positionInput.value in nested forms
// automatically by observing element children (no need to manually call `setPositions`)

import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { useMutation } from "stimulus-use"

export default class extends Controller {
  static values = {
    handleSel: {type: String, default: ".sortable-handle"},
  }

  connect () {
    this.sortable = Sortable.create(
      this.element, // container with itemTargets
      {
        // onUpdate: this.setPositions.bind(this),
        handle: this.handleSelValue,
        animation: 150,
      }
    );
    useMutation(this, {
      childList: {attributes: true},
    })
    this.toggleHandles()
  }

  // Private
  mutate (_entries) {
    console.log("sorting...")
    this.toggleHandles()
    this.setPositions()
  }

  get visibleChildren () {
    return Array.from(this.element.children)
      .filter(el => el.checkVisibility())
  }

  setPositions () {
    this.visibleChildren
      .map(el => el.querySelector("input[name$='[position]']"))
      .filter(el => !!el)
      .forEach((positionInput, i) => {
        positionInput.value = i + 1;
      })
  }

  // handles visibility if handles initially rendered with 'd-none' or 'invisible' class
  // when items count changed from 1 to 2 (visible handles) and from 2 to 1 (unnecessary handle hidden) (mutation observer)
  // internal state this.hideHandleClass stored when called in connect()
  toggleHandles () {
    const handles = this.visibleChildren
      .map(el => el.querySelector(this.handleSelValue))
      .filter(el => !!el)
    if (!this.hideHandleClass) {
      const classList = handles[0]?.classList
      this.hideHandleClass = classList && (
        classList.contains("d-none") ? "d-none"
        : classList.contains("invisible") ? "invisible"
        : undefined
      )
    }
    if (this.hideHandleClass) {
      handles.forEach((handle) => {
        handle.classList.toggle(this.hideHandleClass, handles.length <= 1)
      })
    }
  }
}
